import React from 'react';

import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import { Icon } from '@/components';

interface ToTopButtonProps {
  show?: boolean;
  scrollY?: number;
  spareBottom?: boolean;
}

export function ToTopButton(props: ToTopButtonProps) {
  const moveToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const moveToDown = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  return (
    <>
      <Top show spareBottom={props.spareBottom} onClick={moveToTop}>
        <Icon icon="ArrowUpLight" size={16} />
      </Top>
      <Down show spareBottom={props.spareBottom} onClick={moveToDown}>
        <Icon icon="ArrowDownLight" size={16} />
      </Down>
    </>
  );
}

const Top = styled.div<Pick<ToTopButtonProps, 'show' | 'spareBottom'>>`
  z-index: 20;
  position: fixed;
  right: 0;
  margin-right: 12px;
  bottom: ${(props) => (props.spareBottom ? '104px' : '140px')};
  width: 40px;
  height: 40px;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.gray200};
  border-radius: 50%;
  background-color: ${colors.white};
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  @media (min-width: 600px) {
    margin: 0 auto;
    left: 400px;
  }
`;

const Down = styled.div<Pick<ToTopButtonProps, 'show' | 'spareBottom'>>`
  z-index: 20;
  position: fixed;
  right: 0;
  margin-right: 12px;

  @media (min-width: 600px) {
    margin: 0 auto;
    left: 400px;
  }

  bottom: ${(props) => (props.spareBottom ? '104px' : '95px')};
  width: 40px;
  height: 40px;
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${colors.gray200};
  border-radius: 50%;
  background-color: ${colors.white};
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;
